'use client';

import { generateApi } from '@api/index.api';
import { getRequestId } from '@utils/getRequestId';

const ENV_API_URL = import.meta.env.VITE_API_URL;

const IS_NOT_PRODUCTION =
  import.meta.env.VITE_APP_STAGING === 'true' || import.meta.env.DEV;

export function useTempApi(orderId: string) {
  const baseURL = IS_NOT_PRODUCTION ? ENV_API_URL : window.location.origin;
  const requestId = getRequestId(orderId);
  return generateApi(baseURL, requestId);
}

export function getBaseURL() {
  return IS_NOT_PRODUCTION ? ENV_API_URL : window.location.origin;
}
